import React from 'react';
import FAQSection from './FAQSection';
import FiveFAQSection from './FiveFAQSection';
import { TopFAQ } from './IFaq';
import Breadcrumbs from '../../components/Breadcrumbs';
import ImageLayout from '../../layouts/ImageLayout';
import Container from '../../components/ui/Container';
import { default as BannerImage } from '../../assets/images/banner-faq-index.jpg';
import Panel from '../../components/ui/Panel';

export const FAQIndexPage: React.FC<TopFAQ> = ({ faqs }) => {
  const breadcrumbLinks = [
    { name: 'Home', linkTo: '/' },
    { name: 'Veelgestelde vragen', linkTo: '/home/faq' },
  ];

  return (
    <ImageLayout
      breadcrumbs={<Breadcrumbs variant="inverted" links={breadcrumbLinks} />}
      image={BannerImage as string}
    >
      <Container state="imageLayoutFirst">
        <Panel variant="collapsed" position="last">
          <Panel.Content className="lg:w-[370px]">
            <FAQSection />
          </Panel.Content>
          <Panel.Sidebar className="lg:w-[calc(100%-370px)]">
            <FiveFAQSection faqs={faqs} />
          </Panel.Sidebar>
        </Panel>
      </Container>
    </ImageLayout>
  );
}

FAQIndexPage.displayName = "Page:FaqIndex";

export default FAQIndexPage;